module.exports = __webpack_public_path__ + "static/img/esrb_2021 .fee4095.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/esrb_2021 .svg
// module id = SyKM
// module chunks = 1